export default __webpack_public_path__ + "static/media/cp_geo_dz.95fc6133.svg";